import React from "react";
import { Box, Typography } from "@material-ui/core";
import useTranslate from "../../hooks/use-translate";

export default function OrDevider() {
  const t = useTranslate();
  return (
    <Box display="flex" alignItems="center">
      <Box flex={1} bgcolor="grey.400" height="1px" />
      <Box paddingX={2}>
        <Typography variant="body1">{t("or")}</Typography>
      </Box>
      <Box flex={1} bgcolor="grey.400" height="1px" />
    </Box>
  );
}
